import React, {useState} from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "../defaults/Footer";
import Navbar from "../defaults/Navbar";
import AllBocksDocs from "../AllBlocksDocs";
import Auction from "../Auction";
import AuctionCollection from "../Auction/AuctionCollection";
import Terms from "../Terms";
import Creator from "../Creator";
import MyCollection from "../MyCollection";
import AboutUs from "../AboutUs";
import Nft from "../Nft";
import NftCollection from "../Nft/NftCollection";
import TopNft from "../TopNft";
import Stats from "../Stats";
import Favourites from "../Favourites";
import TopSelling from "../TopSelling";
import Home from "../Home";
import MyWallet from "../MyWallet";
import Explore from "../Explore";
import Burn from "../Burn/Index";
import AllNft from "../AllNft";
import MyWatchlist from "../MyWatchlist";
import Reward from "../Reward";
import Blog from "../Blog";
import Partner from "../Partner";
import GasFee from "../GasFee";
import Career from "../Career";
import Profile from "../Profile";
import Settings from "../Settings";
import Create from "../Create";
import Congrats from "../Congrats";
import ProfileDetails from "../ProfileDetails";
const Main = () => {
    const [isDark, setDark] = useState(false);
    const handelDarkMode = () => {
        setDark(!isDark);
    }
    return (
        <>
            <BrowserRouter>
                <Navbar handleDarkmode={handelDarkMode} darkMode={isDark}/>
                <Routes>
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/auction" element={<Auction />} />
                    <Route path="/auction-collection" element={<AuctionCollection />} />
                    <Route path="/favourites" element={<Favourites />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/creator" element={<Creator />} />
                    <Route path="/mycollection" element={<MyCollection />} />
                    <Route path="/allblocksdocs" element={<AllBocksDocs />} />
                    <Route path="/nft" element={<Nft />} />
                    <Route path="/nft-collection" element={<NftCollection />} />
                    <Route path="/stats" element={<Stats />} />
                    <Route path="/top-nft" element={<TopNft />} />
                    <Route path="/top-selling" element={<TopSelling />} />
                    <Route path="/" element={<Home darkMode={isDark} />} />
                    <Route path="/mywallet" element={<MyWallet />} />
                    <Route path="/explore" element={<Explore />} />
                    <Route path="/burn" element={<Burn/>} />
                    <Route path="/allnft" element={<AllNft/>} />
                    <Route path="/mywatchlist" element={<MyWatchlist/>} />
                    <Route path="/reward" element={<Reward/>} />
                    <Route path="/blog" element={<Blog/>} />
                    <Route path="/partner" element={<Partner/>} />
                    <Route path="/gasfee" element={<GasFee/>} />
                    <Route path="/career" element={<Career/>} />
                    <Route path="/profile" element={<Profile/>} />
                    <Route path="/settings" element={<Settings/>} />
                    <Route path="/create" element={<Create/>} />
                    <Route path="/congrats" element={<Congrats/>} />
                    <Route path="/profiledetails" element={<ProfileDetails/>} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </>
    )
}
export default Main;